export default __webpack_public_path__ + "static/media/active-exchange-white.8a4ff3c5.svg";